import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 bg-gray-700 bg-opacity-80 transition-opacity"
}
const _hoisted_2 = {
  key: 0,
  class: "fixed inset-0 overflow-hidden"
}
const _hoisted_3 = { class: "absolute inset-0 overflow-hidden" }
const _hoisted_4 = { class: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10" }
const _hoisted_5 = { class: "pointer-events-auto relative w-screen max-w-md" }
const _hoisted_6 = { class: "absolute left-0 top-0 -ml-8 flex pr-2 pt-4 sm:-ml-10 sm:pr-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-2.5" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close panel", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "flex h-full flex-col overflow-y-scroll bg-gray-100 py-6 shadow-xl" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col px-6 sm:px-6"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "HANDLINGSLOG", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary font-medium text-lg" }, "Bemærkning", -1)
const _hoisted_15 = { class: "py-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 text-sm" }, "Bemærkning", -1)
const _hoisted_17 = {
  key: 1,
  class: "flex flex-col px-6 sm:px-6"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "HANDLINGSLOG", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary font-medium text-lg" }, "Bemærkning", -1)
const _hoisted_20 = { class: "py-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z"
  })
], -1)
const _hoisted_22 = {
  key: 0,
  class: "mt-2 text-gray-700 text-sm w-36 text-center"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 text-sm" }, "Bemærkning", -1)
const _hoisted_26 = { class: "py-3" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 2,
  class: "flex flex-col px-6 sm:px-6"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "HANDLINGSLOG", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary font-medium text-lg" }, "Bemærkning", -1)
const _hoisted_31 = { class: "py-6" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z"
  })
], -1)
const _hoisted_33 = {
  key: 0,
  class: "mt-2 text-gray-700 text-sm w-36 text-center"
}
const _hoisted_34 = ["src"]
const _hoisted_35 = ["src"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 text-sm" }, "Bemærkning", -1)
const _hoisted_37 = { class: "py-3 space-y-4" }
const _hoisted_38 = ["disbled"]

import bookingRepository from '@/repositories/bookings/bookingRepository'
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import imageDeleteIcon from '@/assets/icons/image-delete-icon.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'logDetailsComponent',
  props: {
  isVisibleLog: Boolean
},
  setup(__props) {

const props = __props

const store = useStore()
const route = useRoute()
const id = route.params.id
const close = () => {
  store.commit('logStore/toggleLogOpen')
}

const logDetails = computed(() => store.getters['logStore/logDetails'])
const mode = computed(() => store.getters['logStore/dataMode'])


const newLog = ref({
  details: '',
  imageReference: null,
  reL_Booking: id
})

const updateLogDetails = ref({ ...logDetails.value, reL_Booking: id })

const hasChanges = computed(() => {
  return JSON.stringify(updateLogDetails.value) !== JSON.stringify({ ...logDetails.value, reL_Booking: id })
})

watch(logDetails, (newVal) => {
  updateLogDetails.value = {
    ...newVal,
    reL_Booking: id
  }
  selectedFile.value = null
})

const saveLog = async () => {
  try {
    const saveValue = mode.value === 'update' ? updateLogDetails.value : newLog.value
    await bookingRepository.saveManualLog(saveValue)
    store.commit('logStore/toggleLogOpen')
    store.dispatch('logStore/getBookingDriverLog', id)
    newLog.value = {
      details: '',
      imageReference: null,
      reL_Booking: id
    }
  } catch (error) {
    console.log('error', error)
  }
}

const deleteLog = async () => {
  try {
    await bookingRepository.deleteManualLog(updateLogDetails.value.id, updateLogDetails.value.reL_Booking)
    store.commit('logStore/toggleLogOpen')
    store.dispatch('logStore/getBookingDriverLog', id)
  } catch (error) {
    console.log('error', error)
  }
}

const selectedFile = ref(null)
const fileInput = ref<File | null>(null)
const triggerFileInput = () => {
  if (fileInput.value !== null) {
    fileInput.value.click()
  }
}

const handleFileChange = (event: Event) => {
  const files = (event.target as HTMLInputElement).files
  if (files && files.length > 0) {
    const file = files[0]
    selectedFile.value = file
    const reader = new FileReader()
    reader.onload = (e) => {
      if (mode.value === 'update') {
        updateLogDetails.value.imageReference = e.target?.result
        imageMarkedForDeletion.value = false
      } else {
        newLog.value.imageReference = e.target?.result
      }
    }
    reader.readAsDataURL(file)
  }
}

const imageUrl = computed(() => {
  return selectedFile.value ? URL.createObjectURL(selectedFile.value) : null
})

const imageMarkedForDeletion = ref(false)
const removeImage = () => {
  selectedFile.value = null
  if (fileInput.value) {
    fileInput.value.value = ''
  }

  if (mode.value === 'update') {
    imageMarkedForDeletion.value = true
    updateLogDetails.value.imageReference = null
  } else {
    newLog.value.imageReference = null
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fixed inset-0 z-50", __props.isVisibleLog ? 'pointer-events-auto' : 'pointer-events-none']),
    "aria-labelledby": "slide-over-title",
    role: "dialog",
    "aria-modal": "true"
  }, [
    _createVNode(_Transition, {
      name: "fade",
      "enter-active-class": "ease-in-out duration-500",
      "leave-active-class": "ease-in-out duration-500",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (__props.isVisibleLog)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "slide",
      "enter-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
      "enter-from-class": "translate-x-full",
      "enter-to-class": "translate-x-0",
      "leave-active-class": "transform transition ease-in-out duration-500 sm:duration-700",
      "leave-from-class": "translate-x-0",
      "leave-to-class": "translate-x-full"
    }, {
      default: _withCtx(() => [
        (__props.isVisibleLog)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (close())),
                        type: "button",
                        class: "relative rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                      }, _hoisted_10)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      (mode.value === 'read')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _hoisted_13,
                            _hoisted_14,
                            _createElementVNode("div", _hoisted_15, [
                              _hoisted_16,
                              _withDirectives(_createElementVNode("textarea", {
                                class: "rounded-md w-full resize-none border text-primary border-gray-300 p-3 h-32",
                                placeholder: "Skriv din bemærkning",
                                disabled: "",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((logDetails.value.details) = $event))
                              }, null, 512), [
                                [_vModelText, logDetails.value.details]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (mode.value === 'create')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _hoisted_18,
                            _hoisted_19,
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (triggerFileInput())),
                                class: "p-4 border-dashed border-2 h-36 border-gray-300 rounded flex flex-col items-center justify-center relative overflow-visible"
                              }, [
                                _hoisted_21,
                                (!selectedFile.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, " Vælg eller tag evt. billede til dokumentation "))
                                  : _createCommentVNode("", true),
                                (imageUrl.value)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: imageUrl.value,
                                      class: "absolute top-0 left-0 w-full h-full object-cover rounded"
                                    }, null, 8, _hoisted_23))
                                  : _createCommentVNode("", true),
                                (imageUrl.value)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 2,
                                      onClick: _withModifiers(removeImage, ["stop"]),
                                      src: _unref(imageDeleteIcon),
                                      class: "absolute -top-3 -right-3 cursor-pointer"
                                    }, null, 8, _hoisted_24))
                                  : _createCommentVNode("", true),
                                _createElementVNode("input", {
                                  type: "file",
                                  ref_key: "fileInput",
                                  ref: fileInput,
                                  onChange: handleFileChange,
                                  accept: "image/*",
                                  class: "hidden"
                                }, null, 544)
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_25,
                              _withDirectives(_createElementVNode("textarea", {
                                class: "rounded-md w-full resize-none border text-primary border-gray-300 p-3 h-32",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newLog.value.details) = $event))
                              }, null, 512), [
                                [_vModelText, newLog.value.details]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("button", {
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (saveLog())),
                                disabled: !newLog.value.details,
                                class: _normalizeClass([{ 'opacity-20 pointer-events-none': !newLog.value.details }, "flex w-full justify-center rounded-md bg-primary px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary"])
                              }, " Opret som bemærkning ", 10, _hoisted_27)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (mode.value === 'update')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _hoisted_29,
                            _hoisted_30,
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", {
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (triggerFileInput())),
                                class: "p-4 border-dashed border-2 h-36 border-gray-300 rounded flex flex-col items-center justify-center relative overflow-visible"
                              }, [
                                _hoisted_32,
                                (!updateLogDetails.value.imageReference)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, " Vælg eller tag evt. billede til dokumentation "))
                                  : _createCommentVNode("", true),
                                (updateLogDetails.value.imageReference)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: updateLogDetails.value.imageReference,
                                      class: "absolute top-0 left-0 w-full h-full object-cover rounded"
                                    }, null, 8, _hoisted_34))
                                  : _createCommentVNode("", true),
                                (updateLogDetails.value.imageReference)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 2,
                                      onClick: _withModifiers(removeImage, ["stop"]),
                                      src: _unref(imageDeleteIcon),
                                      class: "absolute -top-3 -right-3 cursor-pointer"
                                    }, null, 8, _hoisted_35))
                                  : _createCommentVNode("", true),
                                _createElementVNode("input", {
                                  type: "file",
                                  ref_key: "fileInput",
                                  ref: fileInput,
                                  onChange: handleFileChange,
                                  accept: "image/*",
                                  class: "hidden",
                                  capture: "environment"
                                }, null, 544)
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _hoisted_36,
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((updateLogDetails.value.details) = $event)),
                                class: "rounded-md w-full resize-none border text-primary border-gray-300 p-3 h-32"
                              }, null, 512), [
                                [_vModelText, updateLogDetails.value.details]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("button", {
                                disbled: !hasChanges.value,
                                class: _normalizeClass([{ 'opacity-20 pointer-events-none': !hasChanges.value }, "flex w-full justify-center rounded-md bg-primary px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary"]),
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (saveLog()))
                              }, " Gem ændringer ", 10, _hoisted_38),
                              _createElementVNode("button", {
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (deleteLog())),
                                class: "flex w-full justify-center font-medium text-red-500 underline underline-offset-2"
                              }, " Slet denne bemærkning ")
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})